import { LogErrors } from './../LogErrors'


// const CalculateAge = async (date) => {
//     try {
//         const birthDate = new Date(date)
//         const today = new Date()
        
//         let age = today.getFullYear() - birthDate.getFullYear()

//         const currentMonth = today.getMonth()
//         const currentDay = today.getDate()
//         const birthMonth = birthDate.getMonth()
//         const birthDay = birthDate.getDate()

//         // Subtract one year if the birthday hasn't occurred yet this year
//         if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
//             age--
//         }

//         return { success: true, data: age}
//     } catch (error) {
//         await LogErrors('CalculateAge BL RegisteredApplicants', error)
//         return { success: false, message: ''}
//     }
// }

const CalculateAge = async (date) => {
    try {
        if (date) {
            const [year, month, day] = date.split('-')
            const birthDate = new Date(Number(year), Number(month) - 1, Number(day)) // ← local date sin desfase
            const today = new Date()
            
            let age = today.getFullYear() - birthDate.getFullYear()
    
            const currentMonth = today.getMonth()
            const currentDay = today.getDate()
            const birthMonth = birthDate.getMonth()
            const birthDay = birthDate.getDate()
    
            // Subtract one year if the birthday hasn't occurred yet this year
            if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
                age--
            }
    
            return { success: true, data: age }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        await LogErrors('CalculateAge BL RegisteredApplicants', error)
        return { success: false, message: '' }
    }
}


// const FormatDate = async (date) => {
//     try {
//         const dateObj = new Date(date)
//         const day = dateObj.getDate().toString().padStart(2, '0')
//         const month = (dateObj.getMonth() + 1).toString().padStart(2, '0') // Months start at 0
//         const year = dateObj.getFullYear()

//         return { success: true, data: `${day}/${month}/${year}` }
//     } catch (error) {
//         await LogErrors('FormatDate BL RegisteredApplicants', error)
//         return { success: false, message: ''}
//     }
// }

const FormatDate = async (date) => {
    try {
        if (date) {
            const [year, month, day] = date.split('-') // "1990-01-10" -> [1990, 01, 10]

            const dateObj = new Date(Number(year), Number(month) - 1, Number(day)) // month es 0-indexed

            const formattedDay = dateObj.getDate().toString().padStart(2, '0')
            const formattedMonth = (dateObj.getMonth() + 1).toString().padStart(2, '0')
            const formattedYear = dateObj.getFullYear()

            return { success: true, data: `${formattedDay}/${formattedMonth}/${formattedYear}` }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {
        await LogErrors('FormatDate BL RegisteredApplicants', error)
        return { success: false, message: '' }
    }
}

export { CalculateAge, FormatDate };